<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="24" class='flex'>
        <el-select v-if="theUserProject==0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-input
          v-model="getUserCoachList_data.ucTeacherName"
          placeholder="请输入讲师名称"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-input
          v-model="getUserCoachList_data.customName"
          placeholder="请输入客户名称"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-input
          v-model="getUserCoachList_data.userName"
          placeholder="请输入学员名称"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-button
          v-click.getUserCoachList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getUserCoachList'
      api='getUserCoachList'
      updateapi='updateCircleLetter'
      :height="H-165" >
    </mytable> 
    <myform view.getUserCoachDetails='详情' >
     
      <div v-if="getUserCoachDetails_data && getUserCoachDetails_data.data">
        <el-card>
          <div>
            讲师 : {{getUserCoachDetails_data.data.ucTeacherName}};

          </div>
          <div>
            客户 : {{getUserCoachDetails_data.data.customName}}
          </div>
          <div>
            学员 : {{getUserCoachDetails_data.data.userName}}
          </div>
          <div>
            问题 : {{getUserCoachDetails_data.data.ucContext}}
          </div>
          <div>
            讲师回答 : {{getUserCoachDetails_data.data.ucAnswer}}
          </div>
          <div>
            回答时间 : {{getUserCoachDetails_data.data.ucAnswerTime}}
          </div>
          <div>
            辅导类型: {{getUserCoachDetails_data.data.ouId?'商机':'打卡'}}
          </div>
        </el-card>
        <el-descriptions :column="1" border :labelStyle="{
          color: '#409EFF',
          textAlign: 'center',
          width: '20%',
          fontSize: '12px'
        }" :contentStyle="{ textAlign: 'left', width: '80%', fontSize: '12px' }" v-if="getUserCoachDetails_data.data.uvId">
          <el-descriptions-item
            :contentStyle="{ textAlign: 'center', fontSize: '12px', display: 'flex', justifyContent: 'space-around' }"
            label="客户名称">
            {{ getUserCoachDetails_data.data.userVisitor.customName }}
            <div v-if="!companyFold"> <i class="el-icon-circle-plus-outline" style="font-size: 20px;"
                @click="companyFold = true"></i></div>
            <div v-else> <i class="el-icon-remove-outline" style="font-size: 20px;" @click="companyFold = false"></i>
            </div>
          </el-descriptions-item>
          <template v-if="companyFold">
            <el-descriptions-item label="公司网络条数">{{ getUserCoachDetails_data.data.userVisitor.userVisitorCompany.yuvcNetworkNum }}</el-descriptions-item>
            <el-descriptions-item label="公司网络总费用">{{ getUserCoachDetails_data.data.userVisitor.userVisitorCompany.yuvcNetworkMoney
            }}</el-descriptions-item>
            <el-descriptions-item label="公司固话所属运营商">{{ getUserCoachDetails_data.data.userVisitor.userVisitorCompany.yuvcFixedlineOperator
            }}</el-descriptions-item>
            <el-descriptions-item label="公司固话数量">{{ getUserCoachDetails_data.data.userVisitor.userVisitorCompany.yuvcFixedlineNum
            }}</el-descriptions-item>
            <el-descriptions-item label="公司固话到期时间">{{ getUserCoachDetails_data.data.userVisitor.userVisitorCompany.yuvcFixedlineExpirationDate
            }}</el-descriptions-item>
            <el-descriptions-item label="公司固话总费用">{{ getUserCoachDetails_data.data.userVisitor.userVisitorCompany.yuvcFixedlineMoney
            }}</el-descriptions-item>
            <el-descriptions-item label="公司业务总支出">{{ getUserCoachDetails_data.data.userVisitor.userVisitorCompany.yuvcTotalMoney
            }}</el-descriptions-item>
            <template v-for="(item, index) in getUserCoachDetails_data.data.userVisitor.userVisitorCompany.userVisitorKeyuserList">
              <el-descriptions-item :label="'公司-联系人信息' + (index + 1)">{{ item.yuvkName }}</el-descriptions-item>
              <el-descriptions-item label="公司-联系方式">{{ item.yuvkContract }}</el-descriptions-item>
              <el-descriptions-item label="公司-职务">{{ item.yuvkPost }}</el-descriptions-item>
              <el-descriptions-item label="公司-号卡运营商">{{ item.yuvkOperator }}</el-descriptions-item>
            </template>
            <template v-for="(item, index) in getUserCoachDetails_data.data.userVisitor.userVisitorCompany.userVisitorNetworkList">
              <el-descriptions-item :label="'公司-所属运营商' + (index + 1)">{{ item.yuvnOperator }}</el-descriptions-item>
              <el-descriptions-item label="公司-带宽">{{ item.yuvnBandwidth }}</el-descriptions-item>
              <el-descriptions-item label="公司-到期时间">{{ item.yuvnExpirationDate }}</el-descriptions-item>
              <el-descriptions-item label="公司-费用">{{ item.yuvnMoney }}</el-descriptions-item>
            </template>
          </template>

          <el-descriptions-item span="1" label="楼宇名称">{{ getUserCoachDetails_data.data.userVisitor.userVisitorBuilding.yuvbName }}</el-descriptions-item>
          <el-descriptions-item span="1" label="楼宇地址">{{ getUserCoachDetails_data.data.userVisitor.userVisitorBuilding.yuvbAddress
          }}</el-descriptions-item>
          <el-descriptions-item label="物业名称"
            :contentStyle="{ textAlign: 'center', fontSize: '12px', display: 'flex', justifyContent: 'space-around' }">{{
              getUserCoachDetails_data.data.userVisitor.userVisitorProperty.yuvpName }}
            <div v-if="!PropertyFold">
              <i class="el-icon-circle-plus-outline" style="font-size: 20px;" @click="PropertyFold = true"></i>
            </div>
            <div v-else>
              <i class="el-icon-remove-outline" style="font-size: 20px;" @click="PropertyFold = false"></i>
            </div>
          </el-descriptions-item>
          <template v-if="PropertyFold">
            <el-descriptions-item label="物业网络条数">{{ getUserCoachDetails_data.data.userVisitor.userVisitorProperty.yuvpNetworkNum }}</el-descriptions-item>
          <el-descriptions-item label="物业网络总费用">{{ getUserCoachDetails_data.data.userVisitor.userVisitorProperty.yuvpNetworkMoney
          }}</el-descriptions-item>
          <el-descriptions-item label="物业固话所属运营商">{{ getUserCoachDetails_data.data.userVisitor.userVisitorProperty.yuvpFixedlineOperator
          }}</el-descriptions-item>
          <el-descriptions-item label="物业固话数量">{{ getUserCoachDetails_data.data.userVisitor.userVisitorProperty.yuvpFixedlineNum
          }}</el-descriptions-item>
          <el-descriptions-item label="物业固话到期时间">{{ getUserCoachDetails_data.data.userVisitor.userVisitorProperty.yuvpFixedlineExpirationDate
          }}</el-descriptions-item>
          <el-descriptions-item label="物业固话总费用">{{ getUserCoachDetails_data.data.userVisitor.userVisitorProperty.yuvpFixedlineMoney
          }}</el-descriptions-item>
          <el-descriptions-item label="物业业务总支出">{{ getUserCoachDetails_data.data.userVisitor.userVisitorProperty.yuvpTotalMoney }}</el-descriptions-item>
          <template v-for="(item, index) in getUserCoachDetails_data.data.userVisitor.userVisitorProperty.userVisitorKeyuserList">
            <el-descriptions-item :label="'物业-联系人信息' + (index + 1)">{{ item.yuvkName }}</el-descriptions-item>
            <el-descriptions-item label="物业-联系方式">{{ item.yuvkContract }}</el-descriptions-item>
            <el-descriptions-item label="物业-职务">{{ item.yuvkPost }}</el-descriptions-item>
            <el-descriptions-item label="物业-号卡运营商">{{ item.yuvkOperator }}</el-descriptions-item>
          </template>
          <template v-for="(item, index) in getUserCoachDetails_data.data.userVisitor.userVisitorProperty.userVisitorNetworkList">
            <el-descriptions-item :label="'物业-所属运营商' + (index + 1)">{{ item.yuvnOperator }}</el-descriptions-item>
            <el-descriptions-item label="物业-带宽">{{ item.yuvnBandwidth }}</el-descriptions-item>
            <el-descriptions-item label="物业-到期时间">{{ item.yuvnExpirationDate }}</el-descriptions-item>
            <el-descriptions-item label="物业-费用">{{ item.yuvnMoney }}</el-descriptions-item>
          </template>
          </template>
          <el-descriptions-item label="拜访结果">{{ getUserCoachDetails_data.data.userVisitor.uvResult
          }}</el-descriptions-item>
           <el-descriptions-item label="拜访时间">{{ getUserCoachDetails_data.data.userVisitor.uvTime
          }}</el-descriptions-item>
          <el-descriptions-item label="商机结果">{{ getUserCoachDetails_data.data.userVisitor.uvResultTwo
          }}</el-descriptions-item>
           <el-descriptions-item label="描述">{{ getUserCoachDetails_data.data.userVisitor.uvFeedback
          }}</el-descriptions-item>
          <template v-if="(getUserCoachDetails_data.data.userVisitor.uvResult == '已经签单' || getUserCoachDetails_data.data.userVisitor.uvResultTwo =='已经签单') && getUserCoachDetails_data.data.userVisitor.opportunityBuilding.opportunityBusiness">
            <el-descriptions-item label="业务名称">{{  getUserCoachDetails_data.data.userVisitor.opportunityBuilding.opportunityBusiness.bcName
          }}</el-descriptions-item>
           <el-descriptions-item label="签约数量">{{  getUserCoachDetails_data.data.userVisitor.opportunityBuilding.opportunityBusiness.ouBusinessNum
          }}</el-descriptions-item>
           <el-descriptions-item label="签约年限">{{  getUserCoachDetails_data.data.userVisitor.opportunityBuilding.opportunityBusiness.obYear
          }}</el-descriptions-item>
           <el-descriptions-item label="年化金额">{{  getUserCoachDetails_data.data.userVisitor.opportunityBuilding.opportunityBusiness.obMoneyYear
          }}</el-descriptions-item>
          <el-descriptions-item label="计费时间">{{  getUserCoachDetails_data.data.userVisitor.opportunityBuilding.opportunityBusiness.obStartTime
          }}</el-descriptions-item>
          </template>
          <template v-if="(getUserCoachDetails_data.data.userVisitor.uvResult == '生成商机' || getUserCoachDetails_data.data.userVisitor.uvResult =='商机跟进') && getUserCoachDetails_data.data.userVisitor.opportunitySj">
            <el-descriptions-item label="商机名称">{{  getUserCoachDetails_data.data.userVisitor.opportunitySj.ouName
          }}</el-descriptions-item>
           <el-descriptions-item label="商机金额">{{  getUserCoachDetails_data.data.userVisitor.opportunitySj.ouMoney
          }}</el-descriptions-item>
           <el-descriptions-item label="商机描述">{{  getUserCoachDetails_data.data.userVisitor.opportunitySj.ouRemark
          }}</el-descriptions-item>
          </template>
          
        </el-descriptions>
        <el-descriptions :column="1" border :labelStyle="{
          color: '#409EFF',
          textAlign: 'center',
          width: '20%',
          fontSize: '12px'
        }" :contentStyle="{ textAlign: 'left', width: '80%', fontSize: '12px' }" v-if="getUserCoachDetails_data.data.ouId">
            <el-descriptions-item
            :contentStyle="{ textAlign: 'center', fontSize: '12px', display: 'flex', justifyContent: 'space-around' }"
            label="客户名称">
            {{ getUserCoachDetails_data.data.opportunity.customName }}
            <div v-if="!companyFold2"> <i class="el-icon-circle-plus-outline" style="font-size: 20px;"
                @click="companyFold2 = true"></i></div>
            <div v-else> <i class="el-icon-remove-outline" style="font-size: 20px;" @click="companyFold2 = false"></i>
            </div>
          </el-descriptions-item>
        <el-descriptions-item   label="业务金额"> {{getUserCoachDetails_data.data.opportunity.ouMoney}}</el-descriptions-item>
        <el-descriptions-item   label="创建人">{{ row.userName }}</el-descriptions-item>
        <el-descriptions-item   label="订单描述">{{ row.ouRemark }}</el-descriptions-item>
        
      </el-descriptions>

      </div>
      <hide slot='ucId' />
    </myform>    
  </div>
</template>

<script>
export default {
  data() {
    return {
      companyFold:false,
      PropertyFold:false,
      companyFold2:false,
      PropertyFold2:false,
      isAnswer:false,
      csAttrId: null,
      theProjectId:"",
      theUserProject:"",
      tableColums_getUserCoachList: {
        $selection: true,

        ucTeacherName: '讲师姓名',

        customName: '客户姓名',

        userName: '学员姓名',

        ouId: '商机id',

        ucContext: '问题描述',

        ucAnswer: '讲师回答',

        ucAnswerTime: '回答时间',
        
        ucStatus: ['状态',,'@v-if: 1:未回答#danger, 2:已回答#success'],
        $operation: [
            '操作', 200,
            this.updateUserCoachAnswer && `@text: 回复#success
              @v-if:$row.ucStatus == 1
             @click: getAnswer($row)
            `,
            this.getUserCoachDetails && `@text: 详情#success
            @click: $form("getUserCoachDetails",$this.row = $row), getUserCoachDetails({ucId:$row.ucId})
            `,
          ],

      },

    };
  },

  watch: {
    
  },

  methods: {
    getAnswer(row){
      this.$prompt('请回复', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                  }).then(({ value }) => {
                   this.updateUserCoachAnswer({ucId:row.ucId,ucAnswer:value}).result(res=>{
                     this.$message({
                       type: 'success',
                       message: '成功'
                     })
                     this.getUserCoachList({projectId:this.theProjectId});
                   })
                  }).catch(() => {
                    this.$message({
                      type: 'info',
                      message: '取消'
                    });
                  });
    },
    theProjectAllChange(e){
      this.theProjectId=e;
      this.getUserCoachList({projectId:this.theProjectId});
    },
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject==0){
      this.getProjectList({pageSize:0});
    }else{
      this.theProjectId=this.theUserProject;
    }
    this.getUserCoachList({projectId:this.theProjectId});
  },
  mounted(){
    
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/help/CoachManage.vue